import { api } from './client'
import type { CadFile, UUID } from '@/types/api'

export const filesApi = {
  list: async (projectId: UUID): Promise<CadFile[]> =>
    (await api.get(`/projects/${projectId}/files`)).data,

  upload: async (projectId: UUID, file: File, onProgress?: (pct: number) => void): Promise<CadFile> => {
    const form = new FormData()
    form.append('file', file)
    const res = await api.post(`/projects/${projectId}/files`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 30 * 60_000, // 大文件 30 分钟（上限 800MB）
      onUploadProgress: (e) => {
        if (e.total && onProgress) {
          onProgress(Math.round((e.loaded / e.total) * 100))
        }
      },
    })
    return res.data
  },

  remove: async (projectId: UUID, fileId: UUID): Promise<void> => {
    await api.delete(`/projects/${projectId}/files/${fileId}`)
  },
}
